import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_CRM_API_URL;
const axios = createAxiosInstance(URL);

export const fetchCustomersMembersTokens = (params = {}) => {
    return axios.get('/api/v1/customers/customers_members_tokens/', { params });
};

export const fetchCustomersTokens = (id, params = {}) => {
    return axios.get(`/api/v1/customers/customers/${id}/token`, { params });
};

export const createCustomersMembersToken = (id, data) => {
    return axios.post(`/api/v1/customers/customers_members/${id}/token/`, data);
};

export const deleteCustomersMembersToken = (id) => {
    return axios.delete(`/api/v1/customers/customers_members_tokens/${id}/`);
};

export const createCustomersToken = (id, data) => {
    return axios.post(`/api/v1/customers/customers/${id}/token/`, data);
};
